export default function Form(){
    return(<div>
        <script src="https://form.formcentric.com/form/formcentric.js" defer></script>

        <div data-fc-id="7471044a-4b69-48d4-817f-28284501c630"></div>
    </div>);
}